// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__fbLkO","wrapper":"layout_wrapper__Ft0em","content":"layout_content__563Cv","devBorder":"layout_devBorder__u4Y_Y"};